import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import RequireAuth from './components/auth/RequireAuth';
import { 
    Home,
    About,
    Error,
    Profile,
    Series,
    Login,
    Unauthorised,
    Main,
    Info,
    Calendar,
    Register,
    Rules,
    Results,
} from "./pages";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [{
        path: "/",
        element: <Home />,
      },{
        path: "/series",
        element: <Series />,
      },{
        path: "/series/:seriesId",
        element: <Main />,
        children: [{
          path: "/series/:seriesId",
          element: <Info />,
        },{
          path: "calendar",
          element: <Calendar />,
        },{
          path: "rules",
          element: <Rules />,
        },{
          path: "results",
          element: <Results />,
        },{
          path: "register",
          element: <Register />,
        }],
      },{
        path: "/about",
        element: <About />,
      },{
        path: "/profile",
        element: <Profile />,
        children: [],
      // },{
      //   element: <RequireAuth allowedRoles={['FrgUsers']}/>,
      //   children: [{
      //       path: "/profile",
      //       element: <Profile />,
      //       children: [],
      //     }],
      }],
  },{
    path: "/signin",
    element: <Login />,
  },{
    path: "/unauthorised",
    element: <Unauthorised />,
  },{
    path: "*",
    element: <Error />,
  },
]);

export default router;
